import { observer } from 'mobx-react-lite'
import { lazy } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useStore } from 'store/useStore'
import { ContainerLK } from 'sections/LKSection/shared/components/ContainerLK/ContainerLK'
import { Margin, Padding } from 'components/ui'
import { Button, Flex, Title } from 'components/uiKit'
import { phonePipe, snilsPipe } from 'utils/pipes'
import { LKRoutesEnum } from 'shared/constants/routes'
import { Country } from 'shared/types/types'

import { ProfileItem } from '../../components/ProfileItem/ProfileItem'
import { PASSPORT_STATUSES } from '../../types'
import { UserModuleKeys } from '../../types'

const ProfilePage = observer(() => {
  const { profileUiStore: uiStore, appStore } = useStore()
  const { user } = uiStore
  const navigate = useNavigate()
  const { t } = useTranslation()

  const getKey = (key: string) => `${UserModuleKeys.profilePage}.${key}`

  return (
    <ContainerLK>
      <Padding py={32}>
        <Title>{t(getKey('Пользователь'))}</Title>
        <Margin mt={32}>
          <Flex gap={20} vertical>
            <ProfileItem label={t(getKey('Фамилия'))}>{user.last_name}</ProfileItem>
            <ProfileItem label={t(getKey('Имя'))}>{user.first_name}</ProfileItem>
            <ProfileItem label={t(getKey('Отчество'))} isVisible={!!user.middle_name}>
              {user.middle_name}
            </ProfileItem>
            <ProfileItem label={t(getKey('Email'))} isVisible={!!appStore.company?.email}>
              {appStore.company?.email ?? ''}
            </ProfileItem>
            <ProfileItem label={t(getKey('СНИЛС'))} isVisible={user.country === Country.RU && !!user.snils}>
              {snilsPipe(user.snils)}
            </ProfileItem>
            <ProfileItem label={t(getKey('Номер телефона для аккаунта'))}>
              {phonePipe(user.phone, user.country)}
            </ProfileItem>
            <ProfileItem
              label={t(getKey('Номер телефона для связи'))}
              isVisible={!!user.additional_phone && uiStore.isOwner}
            >
              {phonePipe(user.additional_phone, user.additional_phone_country)}
            </ProfileItem>
            <ProfileItem
              label={t(getKey('Публичное имя в Telegram'))}
              isVisible={!!user.telegram_login && uiStore.isOwner}
            >
              {user.telegram_login}
            </ProfileItem>
          </Flex>
          <Margin mt={20}>
            <Flex vertical gap={20} style={{ maxWidth: 600 }}>
              <Button onClick={() => navigate(LKRoutesEnum.editRequisites)}>{t(getKey('Редактировать реквизиты'))}</Button>
              {uiStore.appStore.user.info.passport_approve_status !== PASSPORT_STATUSES.approved && (
                <Button onClick={() => navigate(LKRoutesEnum.editPassport)}>{t(getKey('Редактировать паспортные данные'))}</Button>
              )}
              <Button onClick={() => navigate(LKRoutesEnum.editContact)}>{t(getKey('Редактировать контактную информацию'))}</Button>
            </Flex>
          </Margin>
        </Margin>
      </Padding>
    </ContainerLK>
  )
})

export default ProfilePage

export const ProfilePageAsync = lazy(() => import('./ProfilePage'))
